
// array of options for users to select from; imported in Form component
const optionsArray = [
    { query: 'change, life', topicSelection: 'Change'},
    { query: 'happy, happiness, joy', topicSelection: 'Happiness' },
    { query: 'life, work', topicSelection: 'Life' },
    { query: 'love, loving', topicSelection: 'Love' },
    { query: 'success, motivation, inspiration', topicSelection: 'Success' },
    { query: 'wisdom', topicSelection: 'Wisdom' }
];

export default optionsArray;
